import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HookSection } from '../components/HookSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { AudienceSection } from '../components/AudienceSection';
import { TimelineSection } from '../components/TimelineSection';
import { BonusSection } from '../components/BonusSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { FooterSection } from '../components/FooterSection';
import { Divider } from '../components/ui/Divider';
export function SalesPage() {
  return <div className="min-h-screen bg-tea-cream font-body text-tea-charcoal selection:bg-tea-gold/30 selection:text-tea-green overflow-x-hidden" data-id="element-365">
      <HeroSection data-id="element-366" />
      <HookSection data-id="element-367" />
      <Divider data-id="element-368" />
      <ProblemSection data-id="element-369" />
      <MechanismSection data-id="element-370" />
      <AudienceSection data-id="element-371" />
      <Divider data-id="element-372" />
      <TimelineSection data-id="element-373" />
      <BonusSection data-id="element-374" />
      <ProofSection data-id="element-375" />
      <Divider data-id="element-376" />
      <FAQSection data-id="element-377" />
      <PricingSection data-id="element-378" />
      <FooterSection data-id="element-379" />
    </div>;
}